import baseRequest from 'queries/baseRequest';
import { TrancheAuditLogResponse, TrancheAuditLogParams, TrancheAuditLogRecord } from 'types/TrancheAuditLogTypes';

const AUDIT_LOG_BASE_URL = process.env.REACT_APP_LOG_URL;

export const getTrancheAuditLog = async (
  trancheId: string,
  params: TrancheAuditLogParams = {},
): Promise<TrancheAuditLogResponse> => {
  const { page = 0, page_size = 25 } = params;

  return baseRequest<TrancheAuditLogResponse>({
    path: `${AUDIT_LOG_BASE_URL}/api/v1/log_records/object/${trancheId}?page=${page}&page_size=${page_size}`,
    options: {
      method: 'GET',
    },
  });
};

export const getTrancheAuditLogRecord = async (recordId: string): Promise<TrancheAuditLogRecord> => {
  return baseRequest<TrancheAuditLogRecord>({
    path: `${AUDIT_LOG_BASE_URL}/api/v1/log_records/${recordId}`,
    options: {
      method: 'GET',
    },
  });
};
